import { AbstractModel, JsonObject, JsonProperty } from 'projects/core/src/public-api';

@JsonObject('model.DbxPath')
export class DbxPath extends AbstractModel {
    @JsonProperty(String, 'path')
    path: string;
}

